AFRAME.registerComponent('edit-holdings-vr-popup', {
    init: function() {
        this.el.setAttribute('visible', false);
        this.el.setAttribute('scale', '0 0 0');

        this.ticker = null;
        this.quantity = 0;
        this.avgPrice = 0;
        this.onSave = null;

        this.el.sceneEl.addEventListener('theme-changed', () => {
            if (this.el.getAttribute('visible')) {
                this.render();
            }
        });
    },

    setup: function(config) {
        this.ticker = config.ticker;
        this.quantity = config.quantity || 0;
        this.avgPrice = config.avgPrice || 0;
        this.onSave = config.onSave;
        this.render();
    },

    open: function() {
        this.render();
    },

    close: function() {
        const qtyInput = document.querySelector('#vr-watchlist-qty-input');
        if (qtyInput) {
            qtyInput.value = '';
            const qtyText = this.el.querySelector('#vr-edit-holdings-qty-text');
            if (qtyText) qtyText.setAttribute('value', '');
        }
        const priceInput = document.querySelector('#vr-watchlist-price-input');
        if (priceInput) {
            priceInput.value = '';
            const priceText = this.el.querySelector('#vr-edit-holdings-price-text');
            if (priceText) priceText.setAttribute('value', '');
        }
    },

    render: function() {
        this.el.innerHTML = '';
        const isLight = (typeof getCacheItem === 'function' && getCacheItem('mainSettings')?.themeMode === 'Light');
        const bgColor = isLight ? '#F5F5F5' : '#111';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        // Background
        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', 0.8);
        bg.setAttribute('height', 0.6);
        bg.setAttribute('position', '-0.4 -0.3 0');
        bg.setAttribute('color', bgColor);
        bg.setAttribute('radius', 0.02);
        this.el.appendChild(bg);

        // Header
        const title = document.createElement('a-troika-text');
        title.setAttribute('value', `Edit ${this.ticker}`);
        title.setAttribute('font-size', 0.05);
        title.setAttribute('color', txtColor);
        title.setAttribute('position', '0 0.22 0.01');
        title.setAttribute('anchor', 'center');
        this.el.appendChild(title);

        // Content
        const content = document.createElement('a-entity');
        content.setAttribute('position', '0 0.05 0.01');
        this.el.appendChild(content);

        // Inputs Row
        const inputsRow = document.createElement('a-entity');
        inputsRow.setAttribute('position', '0 -0.05 0');
        content.appendChild(inputsRow);

        // Qty
        const qtyGroup = document.createElement('a-entity');
        qtyGroup.setAttribute('position', '-0.18 0 0');
        inputsRow.appendChild(qtyGroup);

        const qtyLabel = document.createElement('a-troika-text');
        qtyLabel.setAttribute('value', '# of Shares');
        qtyLabel.setAttribute('font-size', 0.025);
        qtyLabel.setAttribute('color', '#888');
        qtyLabel.setAttribute('position', '0 0.06 0');
        qtyLabel.setAttribute('anchor', 'center');
        qtyGroup.appendChild(qtyLabel);

        const qtyFocusBorder = document.createElement('a-rounded-box');
        qtyFocusBorder.setAttribute('width', 0.36);
        qtyFocusBorder.setAttribute('height', 0.10);
        qtyFocusBorder.setAttribute('depth', 0.004);
        qtyFocusBorder.setAttribute('color', '#3636E3');
        qtyFocusBorder.setAttribute('position', '0 -0.04 -0.001');
        qtyFocusBorder.setAttribute('radius', 0.012);
        qtyFocusBorder.setAttribute('visible', false);
        qtyGroup.appendChild(qtyFocusBorder);
        this._qtyFocusBorder = qtyFocusBorder;

        const qtyBox = document.createElement('a-rounded-box');
        qtyBox.setAttribute('width', 0.34);
        qtyBox.setAttribute('height', 0.08);
        qtyBox.setAttribute('depth', 0.005);
        qtyBox.setAttribute('color', isLight ? '#DDD' : '#333');
        qtyBox.setAttribute('position', '0 -0.04 0');
        qtyBox.setAttribute('radius', 0.01);
        qtyBox.setAttribute('data-raycastable', '');
        qtyGroup.appendChild(qtyBox);

        const qtyText = document.createElement('a-troika-text');
        qtyText.setAttribute('id', 'vr-edit-holdings-qty-text');
        qtyText.setAttribute('value', this.quantity.toString());
        qtyText.setAttribute('font-size', 0.035);
        qtyText.setAttribute('color', txtColor);
        qtyText.setAttribute('position', '0 -0.04 0.01');
        qtyText.setAttribute('anchor', 'center');
        qtyGroup.appendChild(qtyText);

        const qtyHitbox = document.createElement('a-entity');
        qtyHitbox.setAttribute('position', '0 -0.04 0.012');
        qtyHitbox.setAttribute('geometry', 'primitive: plane; width: 0.34; height: 0.08');
        qtyHitbox.setAttribute('html', 'html:#vr-watchlist-qty-input; cursor:#cursor');
        qtyHitbox.setAttribute('material', 'shader: flat; opacity: 0; transparent: true');
        qtyHitbox.setAttribute('data-raycastable', '');
        qtyGroup.appendChild(qtyHitbox);

        // Price
        const priceGroup = document.createElement('a-entity');
        priceGroup.setAttribute('position', '0.18 0 0');
        inputsRow.appendChild(priceGroup);

        const priceLabel = document.createElement('a-troika-text');
        priceLabel.setAttribute('value', 'Cost Basis');
        priceLabel.setAttribute('font-size', 0.025);
        priceLabel.setAttribute('color', '#888');
        priceLabel.setAttribute('position', '0 0.06 0');
        priceLabel.setAttribute('anchor', 'center');
        priceGroup.appendChild(priceLabel);

        const priceFocusBorder = document.createElement('a-rounded-box');
        priceFocusBorder.setAttribute('width', 0.36);
        priceFocusBorder.setAttribute('height', 0.10);
        priceFocusBorder.setAttribute('depth', 0.004);
        priceFocusBorder.setAttribute('color', '#3636E3');
        priceFocusBorder.setAttribute('position', '0 -0.04 -0.001');
        priceFocusBorder.setAttribute('radius', 0.012);
        priceFocusBorder.setAttribute('visible', false);
        priceGroup.appendChild(priceFocusBorder);
        this._priceFocusBorder = priceFocusBorder;

        const priceBox = document.createElement('a-rounded-box');
        priceBox.setAttribute('width', 0.34);
        priceBox.setAttribute('height', 0.08);
        priceBox.setAttribute('depth', 0.005);
        priceBox.setAttribute('color', isLight ? '#DDD' : '#333');
        priceBox.setAttribute('position', '0 -0.04 0');
        priceBox.setAttribute('radius', 0.01);
        priceBox.setAttribute('data-raycastable', '');
        priceGroup.appendChild(priceBox);

        const priceText = document.createElement('a-troika-text');
        priceText.setAttribute('id', 'vr-edit-holdings-price-text');
        priceText.setAttribute('value', this.avgPrice.toString());
        priceText.setAttribute('font-size', 0.035);
        priceText.setAttribute('color', txtColor);
        priceText.setAttribute('position', '0 -0.04 0.01');
        priceText.setAttribute('anchor', 'center');
        priceGroup.appendChild(priceText);

        const priceHitbox = document.createElement('a-entity');
        priceHitbox.setAttribute('position', '0 -0.04 0.012');
        priceHitbox.setAttribute('geometry', 'primitive: plane; width: 0.34; height: 0.08');
        priceHitbox.setAttribute('html', 'html:#vr-watchlist-price-input; cursor:#cursor');
        priceHitbox.setAttribute('material', 'shader: flat; opacity: 0; transparent: true');
        priceHitbox.setAttribute('data-raycastable', '');
        priceGroup.appendChild(priceHitbox);

        // Buttons
        const buttons = document.createElement('a-entity');
        buttons.setAttribute('position', '0 -0.22 0.02');
        content.appendChild(buttons);

        const cancelBtn = document.createElement('a-entity');
        cancelBtn.setAttribute('position', '-0.15 0 0');
        cancelBtn.setAttribute('ui-button', {
            label: 'Cancel',
            width: 0.18,
            height: 0.07,
            colorScheme: 'primary',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.04
        });
        cancelBtn.addEventListener('click', () => window.WatchlistApp.Popup.closeManual('edit-holdings-vr-popup'));
        buttons.appendChild(cancelBtn);

        const saveBtn = document.createElement('a-entity');
        saveBtn.setAttribute('position', '0.15 0 0');
        saveBtn.setAttribute('ui-button', {
            label: 'Save',
            width: 0.18,
            height: 0.07,
            colorScheme: 'accent',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.04
        });
        saveBtn.addEventListener('click', () => this.handleSave());
        buttons.appendChild(saveBtn);

        this.setupInputs();
    },

    setupInputs: function() {
        const qtyInput = document.querySelector('#vr-watchlist-qty-input');
        const priceInput = document.querySelector('#vr-watchlist-price-input');
        const qtyText = this.el.querySelector('#vr-edit-holdings-qty-text');
        const priceText = this.el.querySelector('#vr-edit-holdings-price-text');

        if (qtyInput) {
            qtyInput.value = this.quantity.toString();
            qtyInput.oninput = (e) => {
                const displayVal = window.WatchlistApp.Utils ? window.WatchlistApp.Utils.truncateInputDisplay(e.target.value) : e.target.value;
                qtyText.setAttribute('value', displayVal);
            };
            qtyInput.onfocus = () => {
                if (this._qtyFocusBorder) this._qtyFocusBorder.setAttribute('visible', true);
                if (this._priceFocusBorder) this._priceFocusBorder.setAttribute('visible', false);
            };
            qtyInput.onblur = () => {
                if (this._qtyFocusBorder) this._qtyFocusBorder.setAttribute('visible', false);
            };
        }
        if (priceInput) {
            priceInput.value = this.avgPrice.toString();
            priceInput.oninput = (e) => {
                const displayVal = window.WatchlistApp.Utils ? window.WatchlistApp.Utils.truncateInputDisplay(e.target.value) : e.target.value;
                priceText.setAttribute('value', displayVal);
            };
            priceInput.onfocus = () => {
                if (this._priceFocusBorder) this._priceFocusBorder.setAttribute('visible', true);
                if (this._qtyFocusBorder) this._qtyFocusBorder.setAttribute('visible', false);
            };
            priceInput.onblur = () => {
                if (this._priceFocusBorder) this._priceFocusBorder.setAttribute('visible', false);
            };
        }
    },

    handleSave: function() {
        const qtyInput = document.querySelector('#vr-watchlist-qty-input');
        const priceInput = document.querySelector('#vr-watchlist-price-input');
        
        const qty = parseFloat(qtyInput?.value || 0) || 0;
        const price = parseFloat(priceInput?.value || 0) || 0;

        if (this.onSave) {
            this.onSave({
                ticker: this.ticker,
                quantity: qty,
                price: price
            });
        }
        window.WatchlistApp.Popup.closeManual('edit-holdings-vr-popup');
    }
});
